
<span class="text-4xl cursor-pointer text-grey-800 material-symbols-rounded" placement="left" #popover="ngbPopover"
  [ngbPopover]="legendPopoverContent" [autoClose]="'outside'" popoverClass="legend-popover-custom-class">
  info
</span>

<ng-template #legendPopoverContent>
  <div class="p-2 body-small-bold">
    <Label> Legend</Label><span class="float-right cursor-pointer material-symbols-rounded"
      (click)="closeLegendPopover()">close</span>
  </div>

  <mat-divider class="mb-3"></mat-divider>

  <div class="mb-1 ">

    @for (legend of legendsByBallotType; track legend) {
      <div class="flex flex-row">
      <span [ngStyle]="{'color': legend?.color}"
            class="text-m material-symbols-rounded"
            id="iec-vote-selection-icon" >
      {{ legend?.icon }}
      </span>
      <span class="p-1 body-small-regular">{{legend?.name}}</span>
      </div>
    }

    @for (legend of commonLegends; track legend) {
      <div class="flex flex-row">
      <span
        [class]="legend?.color"
        class="text-m material-symbols-rounded"
        id="iec-vote-comment-icon"
      >
        {{ legend?.icon }}
      </span>
      <span class="p-1 body-small-regular">{{legend?.name}}</span>
      </div>
    }


  </div>
</ng-template>
